export default function ArticleTemplate({ renderSections }) {
  const sections = renderSections();
  const headerSections = []; // starts with 'article-heading-'
  const sidebarSections = []; // starts with 'article-sidebar-'
  const footerSections = []; // starts with 'article-footer-'
  const articleSections = []; // everything else

  sections.forEach((section) => {
    const name = section.props['data-comp'];
    if (name.startsWith('article-header-')) {
      headerSections.push(section);
      return;
    }
    if (name.startsWith('article-sidebar-')) {
      sidebarSections.push(section);
      return;
    }
    if (name.startsWith('article-footer-')) {
      footerSections.push(section);
      return;
    }
    articleSections.push(section);
  });

  return (
    <article className="flex flex-col bg-white text-black">
      {headerSections.length > 0 ? (
        <header className="mx-auto flex w-full max-w-7xl flex-col gap-16 py-24 px-4">
          {headerSections}
        </header>
      ) : null}
      <div
        className={`${
          sidebarSections.length > 0
            ? 'grid gap-24 md:grid-cols-2 lg:grid-cols-3'
            : ''
        } ${
          headerSections.length ? '' : 'pt-24'
        } mx-auto w-full max-w-7xl px-4`}
      >
        <div className={sidebarSections.length > 0 ? 'lg:col-span-2' : 'px-4'}>
          {articleSections}
        </div>
        {sidebarSections.length > 0 ? <aside>{sidebarSections}</aside> : null}
      </div>
      {footerSections.length > 0 ? <footer>{footerSections}</footer> : null}
    </article>
  );
}

ArticleTemplate.displayName = 'ArticleTemplate';
